import dangerousSportIcon from '../img/svgs/coverages/dangerousSport.svg';
import baggageIcon from '../img/svgs/coverages/luggage.svg';
import houseInsuranceIcon from '../img/svgs/coverages/house.svg';
import travelInconveniencesIcon from '../img/svgs/coverages/travel_inconveniences.svg';
import travelCancellationIcon from '../img/svgs/coverages/travel_cancellation.svg';

export const TRAVEL_SPECIAL_COUNTRIES = {
  GEORGIA: {
    name: 'Georgia',
    code: 'ge',
  },
};

export const TRAVEL_LIMITS = {
  '15kEur': {
    id: '15kEur',
    value: 15000,
    currency: 'eur',
  },
  '30kEur': {
    id: '30kEur',
    value: 30000,
    currency: 'eur',
  },
  '50kEur': {
    id: '50kEur',
    value: 50000,
    currency: 'eur',
  },
  '100kEur': {
    id: '100kEur',
    value: 100000,
    currency: 'eur',
  },
};

export const REGIONS = {
  WW: 'whole_world',
  WW_EXC: 'whole_world_exc_uk_sch_us_ca_au_jp',
  SCH: 'schengen',
  GEORGIA: 'whole_world_exc_uk_sch_us_ca_au_jp',
};

const LITE = 'LITE';
const LITE_PLUS = 'LITE_PLUS';
const ELITE = 'ELITE';
const GEORGIA = 'GEORGIA';

export const TRAVEL_PLANS_LABEL = {
  LITE,
  LITE_PLUS,
  ELITE,
  GEORGIA,
};

export const DEFAULT_SELECTED_TRAVEL_PLAN = {
  [REGIONS.WW]: ELITE,
  [REGIONS.WW_EXC]: ELITE,
  [REGIONS.SCH]: ELITE,
  [REGIONS.GEORGIA]: GEORGIA,
};

export const DEFAULT_SELECTED_LIMIT = {
  [REGIONS.WW]: '50kEur',
  [REGIONS.WW_EXC]: '50kEur',
  [REGIONS.SCH]: '50kEur',
  [REGIONS.GEORGIA]: '50kEur',
};

export const ALLOWED_TRAVEL_LIMITS_BY_REGION = {
  [REGIONS.WW]: ['30kEur', '50kEur', '100kEur'],
  [REGIONS.WW_EXC]: ['30kEur', '50kEur', '100kEur', '15kEur'],
  [REGIONS.SCH]: ['30kEur', '50kEur', '100kEur'],
  [TRAVEL_PLANS_LABEL.GEORGIA]: ['50kEur', '30kEur', '100kEur'],
};

export const ALLOWED_TRAVEL_PLANS_BY_REGION = {
  [REGIONS.WW]: [LITE, ELITE, LITE_PLUS],
  [REGIONS.WW_EXC]: [LITE, ELITE, LITE_PLUS],
  [REGIONS.SCH]: [LITE, ELITE, LITE_PLUS],
  [TRAVEL_PLANS_LABEL.GEORGIA]: [ELITE, LITE_PLUS, GEORGIA],
};

export const TRAVEL_PLANS = {
  LITE: {
    id: LITE,
    label: LITE,
    limits: [TRAVEL_LIMITS['30kEur'], TRAVEL_LIMITS['50kEur']],
    descriptions: [1, 2, 3],
    warnings: [1, 2, 3],
    headColor: 'blue',
    coverages: {},
  },
  GEORGIA: {
    id: GEORGIA,
    label: GEORGIA,
    limits: [
      TRAVEL_LIMITS['30kEur'],
      TRAVEL_LIMITS['50kEur'],
      TRAVEL_LIMITS['100kEur'],
    ],
    descriptions: [1, 2, 3, 4, 5, 6, 7],
    warnings: [],
    headColor: 'green',
    coverages: {
      LUG: {
        id: 'LUG',
        label: 'LUG',
        active: false,
        icon: baggageIcon,
      },
      SPO: {
        id: 'SPO',
        label: 'SPO',
        active: false,
        icon: dangerousSportIcon,
      },
      // Temporary hidden
      // CAS: {
      //   id: 'CAS',
      //   label: 'CAS',
      //   active: false,
      //   icon: cascoCar,
      // },
      INC: {
        id: 'INC',
        label: 'INC',
        active: false,
        icon: travelInconveniencesIcon,
      },
      CA: {
        id: 'CA',
        label: 'CA',
        active: false,
        icon: travelCancellationIcon,
      },
      PR: {
        id: 'PR',
        label: 'PR',
        active: false,
        icon: houseInsuranceIcon,
      },
    },
  },
  ELITE: {
    id: ELITE,
    label: ELITE,
    limits: [
      TRAVEL_LIMITS['15kEur'],
      TRAVEL_LIMITS['30kEur'],
      TRAVEL_LIMITS['50kEur'],
      TRAVEL_LIMITS['100kEur'],
    ],
    descriptions: [1, 2, 3, 4, 5, 6, 7],
    warnings: [],
    headColor: 'green',
    coverages: {
      LUG: {
        id: 'LUG',
        label: 'LUG',
        active: true,
        icon: baggageIcon,
      },
      SPO: {
        id: 'SPO',
        label: 'SPO',
        active: false,
        icon: dangerousSportIcon,
      },
      INC: {
        id: 'INC',
        label: 'INC',
        active: false,
        icon: travelInconveniencesIcon,
      },
      CA: {
        id: 'CA',
        label: 'CA',
        active: false,
        icon: travelCancellationIcon,
        children: {},
      },
      PR: {
        id: 'PR',
        label: 'PR',
        active: false,
        icon: houseInsuranceIcon,
      },
    },
  },
  LITE_PLUS: {
    id: LITE_PLUS,
    label: LITE_PLUS,
    limits: [TRAVEL_LIMITS['30kEur'], TRAVEL_LIMITS['50kEur']],
    descriptions: [1, 2, 3],
    warnings: [1, 2],
    headColor: 'blue',
    coverages: {},
  },
};

export const TRAVEL_PRICE_KEYS = {
  BASE: 'base',
  SUM: 'sum',
};

export const AGE_65 = 65;

export const AGE_75 = 75;

export const AGE_100 = 100;

export const TRAVEL_PLANS_WITH_MAX_AGE_65 = [
  TRAVEL_PLANS.LITE.label,
  TRAVEL_PLANS.LITE_PLUS.label,
  TRAVEL_PLANS.ELITE.label,
  TRAVEL_PLANS.GEORGIA.label,
];

export const TRAVEL_PLANS_BETWEEN_AGES_65_75 = [TRAVEL_PLANS.LITE.label, TRAVEL_PLANS.ELITE.label];

export const TRAVEL_PLANS_BETWEEN_AGES_75_100 = [TRAVEL_PLANS.LITE.label];

// Now contains only [Georgia].
export const DISALLOWED_LITE_COUNTRIES_SHORT_CODES = ['ge'];

export const PACKAGES = [
  { value: 8, month: 1 },
  { value: 15, month: 3 },
  { value: 30, month: 6 },
  { value: 60, year: 1 },
  { value: 90, year: 1 },
  { value: 180, year: 1 },
];

export const SPECIFIED_FOR_GEORGIA_PACKAGES = [
  { value: 90, year: 1, amount: 9900 },
  { value: 180, year: 1, amount: 14900 },
];

export const SCHENGEN_REGION_ID = 1;

export const WORLDWIDE_REGION_ID = 2;

export const GEORGIA_REGION_ID = 8;

export const BRITAIN_COUNTRY_ID = 68;

export const TRAVEL_MIN_AGE = 0;

export const TRAVEL_MAX_AGE = 100;

export const TRAVEL_MIN_DAYS = 3;

export const TRAVEL_MAX_DAYS = 180;

export const ONE_DAY = 1;

export const SUGGESTED_COUNTRIES = ['schengen', 'eg', 'whole_world', 'ae', 'ge'];

export const TRAVEL_GET_MOBILE_CONTRACT_PREFIX = 'travel-contract/get-mobile-contract';

export const TRAVEL_PREFIX = 'travel';

// This constant is responsible to get difference
// when end of day is great than selected date 10 minutes
export const TRAVEL_CALCULATION_DIFFERENCE_MINUTES = 10;

export const TRAVEL_CONTRACT_LINK = {
  hy: 'https://www.efes.am/travel-insurance/travelinsurance',
  en: 'https://www.efes.am/en/travel-insurance/travelinsurance',
};
